module.exports = __webpack_public_path__ + "static/img/partner-logo-3.6246081a.png";